import { render, staticRenderFns } from "./plmtech-get-vender.vue?vue&type=template&id=d6a734d0"
import script from "./plmtech-get-vender.vue?vue&type=script&lang=js"
export * from "./plmtech-get-vender.vue?vue&type=script&lang=js"
import style0 from "./plmtech-get-vender.vue?vue&type=style&index=0&id=d6a734d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports